import { useGetCurrenciesQuery } from "@/api/AppApi/services/company";
import { storeCurrencyCookie } from "@/utils/functions/cookieOperations";
import { useAtom } from "jotai";
import { useEffect } from "react";
import { currencyAtom, currencyCodeAtom } from "./currencyAtom";

export const useInitGlobalState = () => {
  const getCurrincies = useGetCurrenciesQuery();
  const currencies = getCurrincies?.data?.result;
  const [currCurrencyCode, setCurrCurrencyCode] = useAtom(currencyCodeAtom);
  const [_, setCurrentCurrency] = useAtom(currencyAtom);
  useEffect(() => {
    if (getCurrincies.isLoading) return;
    let selectedCurrencyCode = currCurrencyCode;
    if (
      !currCurrencyCode ||
      currCurrencyCode === "" ||
      !currencies?.map((curr) => curr.code).includes(selectedCurrencyCode)
    ) {
      const defaultCurrency = currencies ? currencies[0]?.code : "";
      selectedCurrencyCode =
        currencies?.find((curr) => curr.selected)?.code ?? defaultCurrency;
    }
    setCurrCurrencyCode(selectedCurrencyCode);
    currencies &&
      setCurrentCurrency(
        currencies?.find((curr) => curr.code === selectedCurrencyCode) ??
          currencies[0],
      );
    storeCurrencyCookie(selectedCurrencyCode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getCurrincies.isLoading]);
};
// , router.locale
